import React, { useEffect, useState , useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  setAdminuseraccesslistDatasgetlistActions,
  setadminuseraccessdeleteActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import AdminuserCreate from "./AdminuserCreate";
import Delete from "../../AppComponent/Popup/Delete";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";


const AdminUserRights = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const [currentPage, setCurrentPage] = useState(1);
  const [Datas, setDatas] = useState([]);
  const [search, setsearch] = useState("");
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [UserCreate, setUserCreate] = useState(false);
  const [UserEditPopup, setUserEditPopup] = useState(false);
  const [EditId, setEditID] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState();

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
    };
    dispatch(setAdminuseraccesslistDatasgetlistActions(payload));
  }, [dtpageindex]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesize,
          page: 1,
        };
        dispatch(setAdminuseraccesslistDatasgetlistActions(payload));;
      }, 500),
    []
  );


  // -----Search------------------------
  function tochange(e) {
    setsearch(e);
setdtPageindex(1);
debouncedSearch(e);
    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //   };
    //   // console.log(e, "testnew")
    //   dispatch(setAdminuseraccesslistDatasgetlistActions(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //   };
    //   dispatch(setAdminuseraccesslistDatasgetlistActions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const columns = [
    {
      Header: "Display Name",
      accessor: "display_name",
    },
    {
      Header: "Unique Name",
      accessor: "unique_name",
    },

    {
      Header: "Display Order",
      accessor: "display_order",
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  e.stopPropagation();
                  setUserEditPopup(true);

                  setEditID(row.row.original.id);
                }}
              >
                            <span className="OuterActionSpan">
                            <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>


              {/* <button
                  type="button"
                  class="btn Status"
                  onClick={(e) => {
                    e.stopPropagation()
                    setDeleteId(row.row.original.id);
                    setDeletePopup(true);
                  }}
                >
                  <span>
                    <i
                      class="fa-regular fa-trash-can"
                      style={{
                        fontSize: "15px",
                        paddingRight: "3px",
                        paddingBottom: "3px",
                      }}
                    ></i>
                    Delete
                  </span>
                </button> */}
  
            </div>
          </>
        );
      },
    },
  ];


  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};


  // const HandleSubmits = () => {
  //   if (DeleteID != undefined) {
  //     const payload = {
  //       DeleteID: DeleteID,
  //       currentPage: dtpageindex,
  //     };
  //     dispatch(setadminuseraccessdeleteActions(payload, setDeletePopup(false)));
  //   }
  // };

  // console.log(state.AdminuseraccesslistCall, "AdminuseraccesslistCall");

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Admin User Rights List</h3>

          </div>
          <div className="Add-User col-sm-5">
            <button onClick={(e) => setUserCreate(true)} className="ButtonCSS">
              Create
            </button>
          </div>
        </div>
        <br/>

        <div
          // style={{ padding: " 0px 40px", marginTop: "-13px" }}
          style={{ padding: " 0px 40px", marginTop: "-13px" }}
        >
          <ReactTable
            data={state.AdminuseraccesslistCall.AdminuseraccesslistDatas}
            columns={columns}
            totalItems={state.AdminuseraccesslistCall.Total_Count}
            currentPage={currentPage}
            // onPageChange={handlePageChange}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.AdminuseraccesslistCall.Total_Count}
            //   onPageChange={handlePageChange}
            //   onPageSizeChange={handlePageSizeChange}
            
            Filter={true}
            NoFilter ={true}

          />
        </div>
      </div>
      {UserCreate ? (
        <AdminuserCreate
          show={UserCreate}
          setShow={setUserCreate}
          currentPage={dtpageindex}
          Number={state.AdminuseraccesslistCall.Total_Count + 1}
        />
      ) : null}

      {UserEditPopup && EditId != undefined ? (
        <AdminuserCreate
          show={UserEditPopup}
          setShow={setUserEditPopup}
          EditId={EditId}
          Number={state.AdminuseraccesslistCall.Total_Count + 1}
          currentPage={dtpageindex}
           search={search}
        />
      ) : null}

      {/* {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete access"}
        />
      ) : null} */}
    </>
  );
};

export default AdminUserRights;
